import 'velocity-animate'
import 'velocity-animate/velocity.ui.min'
import selectComponent from 'utilities/select-component'

export default class AccordionList {

    constructor(element) {
        this.$component = selectComponent(element)  
        this.$toggle = this.$component.elements.button
        this.$content = this.$component.elements.list
        this.bindEvents()
    }

    bindEvents() {
        this.$toggle.on('click', () => {
            this.handleToggle()
        })
    }

    handleToggle() {
        if (this.$toggle.attr('data-state') == 'open') {
            this.$content.velocity('slideUp', {
                begin: () => {
                    this.$toggle.children('.fa')
                     .removeClass('fa-minus-square-o')
                     .addClass('fa-plus-square-o')
                },
                complete: () => {
                    this.$toggle.attr('data-state', 'closed')
                }
            })
            return
        }

        this.$content.velocity('slideDown', {
            begin: () => {
                this.$toggle.children('.fa')
                 .removeClass('fa-plus-square-o')
                 .addClass('fa-minus-square-o')
            },
            complete: () => {
                this.$toggle.attr('data-state', 'open')
            }
        })
    }
}